import { lazy } from 'react';

const AddCredentialModal = lazy(
  () => import('modules/CredentialWallet/modals/AddCredentialModal'),
);

const WhatAreCredentialsModal = lazy(
  () => import('modules/CredentialWallet/modals/WhatAreCredentialsModal'),
);

export default {
  ADD_CREDENTIAL_MODAL: AddCredentialModal,
  WHAT_ARE_CREDENTIALS_MODAL: WhatAreCredentialsModal,
};
